"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { FileCheck, Calculator, TrendingUp, ShieldCheck } from "lucide-react";
export default function ServiceCategories() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const services = [{
    id: 1,
    icon: FileCheck,
    title: "Audit & Assurance",
    items: ["Statutory Audits", "Internal Audits", "Liquidation Reports"]
  }, {
    id: 2,
    icon: Calculator,
    title: "Tax Advisory",
    items: ["Corporate Tax compliance (CT)", "VAT Registration", "Tax Residency Certificates"]
  }, {
    id: 3,
    icon: TrendingUp,
    title: "Financial Consulting",
    items: ["Feasibility studies", "Bookkeeping", "Financial Forecasting"]
  }, {
    id: 4,
    icon: ShieldCheck,
    title: "UAE Regulatory Support",
    items: ["ESR (Economic Substance Regulations)", "AML (Anti-Money Laundering) compliance"]
  }];
  return <section ref={sectionRef} className="bg-background py-16 px-6 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className="text-card-foreground flex flex-col gap-6 rounded-xl border border-primary bg-background px-6 py-8 shadow-soft transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] !border-[hsl(22,78%,26%)] border-1 border-solid hover:-translate-y-0.5 hover:shadow-medium" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)",
            transitionDelay: isVisible ? `${i * 50}ms` : "0ms"
          }}>
                <CardHeader className="flex flex-col items-start gap-4 px-0">
                  <Icon className="h-10 w-10 text-primary" strokeWidth={1.5} />
                  <CardTitle className="font-display text-xl font-semibold !text-[hsl(22,78%,26%)]">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-0">
                  <ul className="space-y-2">
                    {service.items.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-muted-foreground">
                        <span className="mt-1.5 h-1 w-1 flex-shrink-0 rounded-full bg-primary" />
                        <span>{item}</span>
                      </li>)}
                  </ul>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}